import styled from "styled-components";

import { CountryDropdown } from "../../../../../../components/Form/PhoneNumberInput/styles";

/** The field: looks like the text fields of the editor, the list opening under it. */
export const Field = styled.div`
  position: relative;
  margin-top: 0.75rem;
  font-family: "Inter", sans-serif;

  .value {
    display: grid;
    /* symbol, name, code and the arrow of a list */
    grid-template-columns: 2.5rem 1fr auto auto;
    gap: 0.75rem;
    align-items: center;
    width: 100%;
    height: 52px;
    padding: 0 1rem;
    border: 2px solid var(--color-neutral-light);
    border-radius: 10px;
    background: transparent;
    color: var(--color-neutral-white);
    font-size: 0.875rem;
    font-weight: 700;
    text-align: left;
    cursor: pointer;

    &[aria-expanded="true"] {
      border-color: var(--color-brand-pink);
    }

    &::after {
      content: "";
      width: 8px;
      height: 8px;
      margin-left: 0.5rem;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: translateY(-2px) rotate(45deg);
    }
  }

  .symbol {
    color: var(--color-neutral-150);
  }

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .code {
    color: var(--color-neutral-light);
    font-size: 0.75rem;
  }
`;

export const Dropdown = styled(CountryDropdown)`
  left: 0;
  width: 100%;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .empty {
    padding: 0.75rem 1rem;
    color: var(--color-neutral-light);
    font-size: 0.8125rem;
  }
`;

/** A currency of the list, like a country of the list of the phone field. */
export const Option = styled.li<{ $active: boolean }>`
  display: grid;
  grid-template-columns: 2.5rem 1fr auto;
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 1rem;
  background: ${({ $active }) => ($active ? "var(--color-neutral-dark)" : "transparent")};
  color: var(--color-neutral-white);
  font-size: 0.8125rem;
  font-weight: 700;
  cursor: pointer;

  /* real, dollar and euro apart from the rest */
  &.divided {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }
`;
